import { defineMessages } from 'react-intl';

export default defineMessages({
    caDetailsBrokenGlass: {
        id: 'fnol.ca.views.ca-glass-details.Details (Broken Glass)',
        defaultMessage: 'Details (Broken Glass)'
    },
    caGlassDamageDetails: {
        id: 'fnol.ca.views.ca-glass-details.Glass Damage Details',
        defaultMessage: 'Glass Damage Details'
    },
    caVehicleDamaged: {
        id: 'fnol.ca.views.ca-glass-details.Which vehicle was damaged?',
        defaultMessage: 'Which vehicle was involved?'
    },
    caGlassChooseVehicle: {
        id: 'fnol.ca.views.ca-glass-details.Choose Vehicle',
        defaultMessage: 'Choose Vehicle'
    },
    caGlassWhatHappened: {
        id: 'fnol.ca.views.ca-glass-details.Please describe what happened',
        defaultMessage: 'What happened?'
    },
    caGlassWhereDidThisHappenPropertyDamage: {
        id: 'fnol.ca.views.ca-glass-loss-details.Where did this happen?',
        defaultMessage: 'Where did this happen?'
    },
    caGlassWhatHappened: {
        id: 'fnol.ca.views.ca-glass-loss-details.What Happened?',
        defaultMessage: 'What Happened?'
    }
});
